import { TangramList } from './../../../../shared';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { Component, Input, OnInit, Renderer2, ViewChild, ElementRef, OnChanges, SimpleChanges, OnDestroy, Output, EventEmitter, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CommonModalComponent } from 'src/app/shared/components/common-modal/common-modal.component';
import { CommonService } from 'src/app/_services/common.service';
import { appConfig } from 'src/app/_core/config/app-config.const';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { environment } from 'src/environments/environment';
import { NgNavigatorShareService } from 'ng-navigator-share';
import { ToastrService } from 'ngx-toastr';
import { TinyUrlService } from '../../services/tinyurl.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'my-tangram',
  templateUrl: './my-tangram.component.html',
  styleUrls: ['./my-tangram.component.scss'],
  // host: {
  //   '(document:click)': 'onClick($event)',
  // },
})
export class MyTangramComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('AlertContent',  { static: true }) alertContent!: TemplateRef<any>;
  @ViewChild('EmbedModalPopupContent', { static: true }) embedModalPopupContent!: TemplateRef<any>;
  imgPath = appConfig.imagePath;
  iconPath = appConfig.iconPath;
  myTangramList: any[];
  allTangramList: any[] = []; // unfiltered snapshot so the toggle is lossless
  activeFilter: 'all' | 'published' | 'drafts' = 'all';
  draftsCount: number = 0;
  publishedCount: number = 0;
  showSideMenuBar: boolean = false;
  currentUser: any;
  placeholderImage: string = "assets/img/videos/img6.png";
  shareUrl: string = '';
  fbShareUrl: string = '';
  inAppShareUrl:string = '';
  whatsAppShareUrl: string = '';
  whatsAppShareUrl1: string = '';
  CurrentSharePathwayId: string = '';
  imgEnvPath = environment.backendUrl;
  private ngNavigatorShareService: NgNavigatorShareService;
  currentPathwayId = ''
  alterMessage = ''
  showFeedbackModal: boolean = false; // To show feedback modal
  isIOS: boolean = false  
  constructor(
    private modalService: NgbModal,
    private cd: ChangeDetectorRef,
    private renderer: Renderer2,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private dashboardService: DashboardService,
    ngNavigatorShareService: NgNavigatorShareService,
    private toasterService: ToastrService,
    private tinyUrlService: TinyUrlService,



    ) {
      this.currentUser = this.authService.currentUserValue;
      this.ngNavigatorShareService = ngNavigatorShareService;

    }

  /**
   * Called when input properties get changed
   * @param changes changes to be got
   */
  ngOnChanges(changes: SimpleChanges) {
    console.log('my-tangram input changes');
  }

  /**
   * Called when component being called
   */
  ngOnInit() {
    console.log('My Tangram Component Initialized');
    this.dashboardService.getMyTangramList().subscribe((response: TangramList<any[]>) => {
      const raw = response.data ? response.data.reverse() : [];
      raw.forEach((el: any) => {
        if (el.imageURL) {
          el.overviewImageUrl = `${environment.backendUrl}${el.imageURL}`;
        } else if (el.tempImageURL) {
          el.overviewImageUrl = el.tempImageURL;
        } else {
          el.overviewImageUrl = "assets/img/videos/img6.png";
        }
      });
      // Keep drafts in the list — they're differentiated by an isDraft flag and
      // a Draft badge. Empty published tangrams (0 media) remain filtered out.
      this.allTangramList = raw.filter((el: any) => el.isDraft || el.totalVideos);
      this.draftsCount = this.allTangramList.filter((t: any) => t.isDraft).length;
      this.publishedCount = this.allTangramList.filter((t: any) => !t.isDraft).length;
      this.applyFilter();
      this.loadTangramExtras();
    });
    this.fbShareUrl = environment.fbShareUrl;
    const details = navigator.userAgent;
    this.inAppShareUrl = environment.inAppShareUrl;
    const regexp = /android|iphone|kindle|ipad/i;
    this.isIOS = /iphone|ipad/i.test(navigator.userAgent);

    /* Using test() method to search regexp in details
    it returns boolean value*/
    const isMobileDevice = regexp.test(details);
    if (isMobileDevice) {
      this.whatsAppShareUrl=environment.whatsAppShareUrlMobile;
    } else {
      this.whatsAppShareUrl=environment.whatsAppShareUrl;
    }
    
  }

  /**
   * Fetch average star rating and completion data for all tangrams in 2 batch requests
   */
  loadTangramExtras() {
    if (!this.allTangramList || !this.allTangramList.length || !this.currentUser) return;

    const pathwayIds = this.allTangramList.map(t => t._id);

    this.dashboardService.getBatchStarRatings(pathwayIds).subscribe((res: any) => {
      if (res.success) {
        this.allTangramList.forEach(tangram => {
          const rating = res.data[tangram._id];
          if (rating) {
            tangram.averageStarRating = rating.averageRating || 0;
            tangram.userStarRating = rating.userRating || 0;
            tangram.totalStarRatings = rating.totalRatings || 0;
          }
        });
      }
    });

    this.dashboardService.getBatchMediaCompletions(pathwayIds).subscribe((res: any) => {
      if (res.success) {
        this.allTangramList.forEach(tangram => {
          const completion = res.data[tangram._id];
          if (completion) {
            tangram.completedCount = (completion.completedVideoIds || []).length;
            tangram.completionPercentage = completion.completionPercentage || 0;
          }
        });
      }
    });
  }

  /**
   * Toggle side menu bar
   */
  toggleSideMenuBar($event: Event) {
    console.log('inside toggleSideMenuBar');
    $event.stopPropagation();
    this.showSideMenuBar = !this.showSideMenuBar;
    // Hide show side menu bar based on status
    if (this.showSideMenuBar) {
      this.renderer.addClass(document.body, 'menu-open');
    }
    else {
      this.renderer.removeClass(document.body, 'menu-open');
    }
  }

  /**
   * Toggle side menu bar when click anywhere
   * @param event
   */
  onClick(event) {
    console.log('inside onClick event');
    if (this.showSideMenuBar) {
       this.toggleSideMenuBar(event);
    } else {
      this.renderer.removeClass(document.body, 'menu-open');
    }
  }

  /**
   * navigate to create a new tangram page
   */
  createTangram() {
    this.router.navigate(['/create-tangram']);
  }
  
  /**
   * Route into the correct flow based on draft state — drafts go to the editor
   * (so the user keeps iterating), published tangrams go to the view page.
   */
  navigateToPathwayDetails(pathway: any) {
    const pathwayId = pathway._id;
    if (pathway && pathway.isDraft) {
      this.router.navigate(['/edit-tangram', pathwayId]);
    } else {
      this.router.navigate(['/dashboard', pathwayId]);
    }
  }

  setFilter(filter: 'all' | 'published' | 'drafts') {
    this.activeFilter = filter;
    this.applyFilter();
  }

  private applyFilter() {
    if (!this.allTangramList) {
      this.myTangramList = [];
      return;
    }
    if (this.activeFilter === 'drafts') {
      this.myTangramList = this.allTangramList.filter((t: any) => t.isDraft);
    } else if (this.activeFilter === 'published') {
      this.myTangramList = this.allTangramList.filter((t: any) => !t.isDraft);
    } else {
      this.myTangramList = [...this.allTangramList];
    }
  }

  //logout user
  logout() {
    this.authService.logout();
    this.router.navigate(["/home"]);
  }

  /**
   * Called when component being destroyed
   */
  ngOnDestroy() {
    console.log('my-tangram component destroyed');
  }

  /**
 * redirects user to share popup
 * @param link to be shared
 */
  shareRedirect(appUrl,link) {
    const shareURL = appUrl + encodeURIComponent(link);
    window.open(shareURL,'popup','width=600,height=600'); 
    return false;
  }  

  copyLink(type){
    // const content = document.getElementById('share-tangram-url').textContent;
    // loading the content into our clipboard
    const link = this.shareUrl;
    navigator.clipboard.writeText(link);
  }

  async openSharePopup(pathwayId) {
    if(this.CurrentSharePathwayId && this.CurrentSharePathwayId !== pathwayId) {
      var popup = document.getElementById("share-popup" + this.CurrentSharePathwayId);
      var btnPopup = document.getElementById("shareBtn" + this.CurrentSharePathwayId);
      if(popup) {
        popup.classList.toggle("show");
      }
      if(btnPopup) {
        btnPopup.classList.toggle("visible");
      }
    }
    const link = environment.appRedirectUrl + '/#/dashboard/' + pathwayId
    this.shareUrl = await this.shortenUrlFunc(link);
    document.getElementById("share-tangram-url" + pathwayId).setAttribute('value', this.shareUrl);
    var popup = document.getElementById("share-popup" + pathwayId);
    var btnPopup = document.getElementById("shareBtn" + pathwayId);
    if(this.isIOS){
      this.ngNavigatorShareService.share({
        title: '',
        // text: 'Sharing My tangram',
        url: this.shareUrl
      }).then( (response) => {
        console.log(response);
      })
      .catch( (error) => {
        console.log(error);
      })    
    }else{
      if(popup) {
        popup.classList.toggle("show");
      }
      if(btnPopup) {
        btnPopup.classList.toggle("visible");
      }
    }
    if(this.CurrentSharePathwayId && this.CurrentSharePathwayId == pathwayId) {
      // this.CurrentSharePathwayId = '';
    } else {
      this.CurrentSharePathwayId = pathwayId;
    }
  }

  /**
   * Open share modal
   * @param content content to be displayed as modal
   */
  openShareModal(content) {
    this.modalService.open(content, { centered: true }).result.then(() => {
    }, () => {
    });
  }

  /**
   * Update overview image url if given url is not valid
   * @param event
   */
  updateOverviewImageUrl(event, i) {
    this.myTangramList[i].overviewImageUrl = "assets/img/videos/img6.png";
  }

  async shortenUrlFunc(longUrl) {
    try {
      const response: any = await this.tinyUrlService.shortenUrl(longUrl).toPromise();
      return response.data.tiny_url; // Return the shortened URL
    } catch (error) {
      console.error('Error occurred while shortening URL:', error);
        this.toasterService.error(error)
        return longUrl;
      }
  }

  showPopup(pathwayId, modalContent: TemplateRef<any>) {
    if(!this.currentUser.subscriptionActive){
      this.modalService.open(modalContent, { centered: true, windowClass : 'unlock-premium' })
      return ;
    }
    this.currentPathwayId = pathwayId
    this.alterMessage = "Do you want to delete this tangram ?"
    this.modalService.open(this.alertContent, { centered: true, windowClass : 'unlock-premium delete-tangram-theme' })
  }
  
  deleteTangram(){
    const data = {
      pathwayId : this.currentPathwayId
    }        
    this.dashboardService.deleteTangram(data).subscribe((res : any) => {
      if(res.success) {
        this.allTangramList = this.allTangramList.filter(t => t._id !== this.currentPathwayId);
        this.draftsCount = this.allTangramList.filter((t: any) => t.isDraft).length;
        this.publishedCount = this.allTangramList.filter((t: any) => !t.isDraft).length;
        this.applyFilter();
        this.currentPathwayId = '';
      }
    })
  }

  /**
   * Open embed modal
   */
  openEmbedModal(pathwayId: string) {
    console.log('pathwayId: ', pathwayId);
    this.CurrentSharePathwayId = pathwayId;
    this.modalService.open(this.embedModalPopupContent, { 
      centered: true, 
      windowClass: 'embed-modal-popup',
      size: 'lg'
    });
  }
}
